import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { EventsService } from 'src/app/core/services/events/events.service';
import { Alert, TypeAlert } from '../../interfaces/alert.interface';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private readonly _eventsServices = inject(EventsService);

  private readonly isShowSubject = new BehaviorSubject<boolean>(false);

  public readonly isShow$ = this.isShowSubject.asObservable();

  private alert: Alert = {
    title: '',
    message: '',
    type: TypeAlert.success,
  };

  get data(): Alert {
    return this.alert;
  }

  set data(alertData: Alert) {
    this.alert = alertData;
  }

  showAlert(data: Alert): void {
    this.alert = data;
    this.isShowSubject.next(true);
    this._eventsServices.handleModalShow(true);
  }

  hideAlert(): void {
    this.isShowSubject.next(false);
    this._eventsServices.handleModalShow(false);
  }
}
